import {Shelf} from 'components/customer/Product/entity/Shelf';
import {DEFAULT_CARCASE_THICKNESS} from 'components/customer/RoomPlanner/constants/cabinetDefaults';

export const mapShelfThickness = (shelves: Shelf[] | undefined): Shelf[] =>
    shelves?.map((shelf) => ({
        ...shelf,
        shelf_thickness:
            Number(shelf.shelf_thickness) || DEFAULT_CARCASE_THICKNESS,
    })) ?? [];
